// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"bbc6f880","296":"d6da71f4","453":"6cefbc99","557":"33887907"}[chunkId] + ".chunk.js";
};